import { Dispatch, SetStateAction } from 'react';
import { API } from '@shared/types/api';
import { createCtx } from '@shared/util/context';

export interface ViewTemplateState {
  viewTemplate: API.ViewTemplateFragment;
  savedViewTemplate: API.ViewTemplateFragment;
  isModified?: boolean;
}

export interface ViewTemplateActions {
  setViewTemplate: Dispatch<SetStateAction<API.ViewTemplateFragment>>;
  revertViewTemplate: VoidFunction;
  saveViewTemplate: () => Promise<void>;
}

export const [useViewTemplateState, ViewTemplateStateProvider] = createCtx<ViewTemplateState>();
export const [useViewTemplateActions, ViewTemplateActionsProvider] =
  createCtx<ViewTemplateActions>();
